<div mat-dialog-content class="py-2 mt-2 text-center rounded">
	<i class="success__dialog__icon fal fa-check-circle"></i>
	<h2 class="success__dialog__title mt-4 mb-0">{{ data.title }}</h2>
	<p class="success__dialog__description" *ngIf="data.message">{{ data.message }}</p>
	<p class="success__dialog__description mt-3 px-3 text-start" *ngFor="let paragraph of data.paragraphs">{{ paragraph }}</p>
</div>
<div mat-dialog-actions class="justify-content-center pb-3 py-2">
	<button class="success__dialog__btn btn btn-primary btn-lg rounded-pill" (click)="closeDialog()">
		<i class="fal fa-check"></i> Entendido
	</button>
</div>
